import { OrganizationUserRolesEnum, OrganizationUserVM } from "@propertelligent/client-api";

/** Blank form values for Add User — always pass explicitly to reset(), never rely on bare reset() after edit. */
export const getEmptyManageUserFormValues = (
  organizationId: number,
): OrganizationUserVM => ({
  id: undefined,
  organizationUserId: undefined,
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  title: "",
  organizationUserTypeId: OrganizationUserRolesEnum.Admin,
  organizationId,
});
